import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { TeamDetailsViewState } from '../../TeamDetailsViewState';
import TeamDetails from '../../views/TeamDetails';
import TeamSelector from '../../views/TeamSelector';
var TeamManagementContainer = /*#__PURE__*/function (_React$Component) {
  function TeamManagementContainer() {
    var _this;
    _classCallCheck(this, TeamManagementContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TeamManagementContainer, [].concat(args));
    _this.state = {
      view: 'TEAMS'
    };
    _this.viewTeam = function (team) {
      if (_this.props.hideSearchBar) {
        _this.props.hideSearchBar(true);
      }
      var rootStore = _this.props.rootStore;
      _this.setState({
        view: 'DETAIL',
        viewState: new TeamDetailsViewState(_objectSpread(_objectSpread({}, rootStore), {}, {
          team: team,
          allowEdit: _this.props.allowEdit,
          onViewList: _this.viewList,
          target: _this.props.invitationTarget
        }))
      });
    };
    _this.viewList = function () {
      if (_this.props.hideSearchBar) {
        _this.props.hideSearchBar(false);
      }
      _this.setState({
        view: 'TEAMS'
      });
    };
    return _this;
  }
  _inherits(TeamManagementContainer, _React$Component);
  return _createClass(TeamManagementContainer, [{
    key: "render",
    value: function render() {
      return this.state.view === 'DETAIL' ? /*#__PURE__*/React.createElement(TeamDetails, {
        state: this.state.viewState,
        onBackClick: this.viewList,
        billingViews: this.props.billingViews
      }) : /*#__PURE__*/React.createElement(TeamSelector, {
        allowCreation: this.props.allowCreation,
        teamManagementStore: this.props.rootStore.teamManagementStore,
        onTeamClick: this.viewTeam
      });
    }
  }]);
}(React.Component);
export { TeamManagementContainer as default };
//# sourceMappingURL=index.js.map
